import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Grid,
  List,
  ListSubheader,
  Popover,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import "./AddInsList.css";
import DataTable from "../Tables/DataTable/DataTable";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import CheckboxList from "../../common/CheckboxList/CheckboxList";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import IosShareRoundedIcon from "@mui/icons-material/IosShareRounded";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  ClearSelectionData,
  SelectionFilter,
  GetAllSelectedIds,
} from "../../utilities/SelectionFilter";
import TableColumnModal from "../../common/TableColumnModal/TableColumnModal";
import { listofAddInsServicesDataColumns } from "../../common/TableColumnModal/DefaultDataColumns";
import ApiServices from "../../services/ApiServices";
import { useLoading } from "../../hooks/useLoader";
import {
  ADDIN_EXPORT,
  ADDIN_LIST,
  ADDIN,
  ADDIN_STATUS,
  MASTER_DATA,
  VENDOR_DROPDOWN,
} from "../../constants/api-constants";
import { toast } from "react-toastify";
import ExportToExcelHandler from "../../utilities/ExportToExcelHandler";
import { MenuListItems } from "../../common/Sidebar/MenuListItems";
import { SystemModulesEnum } from "../../constants/SystemUsers";
import {
  PermissionEnum,
  PermissionService,
} from "../../constants/permissionService";
import { useAddInsContext } from "./AddIns.context";
import Confirmation from "../../common/Confirmation/Confirmation";
import { STATUS_ENUM, TABS } from "../../constants/common";
import { ContentPublishStatus } from "../Distributors/constants";

/*istanbul ignore next */
const AddInsList = (props) => {
  const { showLoader } = useLoading();
  const addInsContext = useAddInsContext();
  const history = useHistory();
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [tableColumnModalVisibility, setTableColumnModalVisibility] =
    useState(false);
  const [vendorTable, setVendorTableData] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [selectedVendors, setSelectedVendors] = useState([]);
  const [selectedAddInTypes, setSelectedAddInTypes] = useState([]);
  const [selectedCostTypes, setSelectedCostTypes] = useState([]);
  const [selectedApplicableTo, setSelectedApplicableTo] = useState([]);
  const [selectedPublishStatus, setSelectedPublishStatus] = useState([]);
  const [vendorOptions, setVendorOptions] = useState([]);
  const [addInTypeOptions, setAddInTypeOptions] = useState([]);
  const [costTypeOptions, setCostTypeOptions] = useState([]);
  const [applicableToOptions, setApplicableToOptions] = useState([]);
  const [confirmation, setConfirmation] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [confirmationAction, setConfirmationAction] = useState("");
  const handleConfirmationOpen = (actionName, cnfMessage) => {
    setConfirmationAction(actionName);
    setConfirmationMessage(cnfMessage);
    setConfirmation(true);
  };
  const handleConfirmationClose = () => {
    setConfirmationAction("");
    setConfirmationMessage("");
    setConfirmation(false);
    setSelectedVendor(null);
  };

  const [query, setQuery] = useState({
    searchText: "",
    SortType: "desc",
    IgnorePaging: false,
    SortColumn: "userId",
    PageNumber: 1,
    PageSize: 10,
    Filter: {
      Status: selectedStatus,
    },
  });

  const buildAddInsListPayload = () => {
    const selectedColumnLabels = (selectedColumns || [])
      .filter((column) => column.isSelected && column.showInSelection)
      .map((column) => column.exportLabel)
      .filter(Boolean);

    return {
      isShowChildUserData: true,
      searchText: query.searchText,
      pageSize: query.PageSize,
      pageNumber: query.PageNumber,
      ignorePaging: query.IgnorePaging,
      sortColumn: query.SortColumn,
      sortType: query.SortType,
      filter: {
        vendorIds: selectedVendors,
        addInType: selectedAddInTypes,
        applicableTo: selectedApplicableTo,
        status: selectedStatus,
        publishStatus: selectedPublishStatus,
        addInServiceCost: selectedCostTypes,
        selectedColumns: selectedColumnLabels,
      },
      isSearchInAllQuery: true,
    };
  };

  useEffect(() => {
    vendorDetails();
  }, [query]);

  useEffect(() => {
    localStorage.setItem("selectedVendorTab", TABS.VENDOR_BASIC);
    // Clear any old selection data when component loads
    ClearSelectionData();
  }, []);

  useEffect(() => {
    setSelectionColumns();
  }, [query]);

  useEffect(() => {
    loadFilterOptions();
  }, []);
  const open = Boolean(anchorEl);
  const onFilterStatusChangeHandler = (values) => {
    setSelectedStatus(values);
  };
  const onFilterVendorChangeHandler = (values) => {
    setSelectedVendors(values);
  };
  const onFilterAddInTypeChangeHandler = (values) => {
    setSelectedAddInTypes(values);
  };
  const onFilterCostTypeChangeHandler = (values) => {
    setSelectedCostTypes(values);
  };
  const onFilterApplicableToChangeHandler = (values) => {
    setSelectedApplicableTo(values);
  };
  const onFilterPublishStatusChangeHandler = (values) => {
    setSelectedPublishStatus(values);
  };

  let moduleId = MenuListItems.find(
    (item) => item.name === SystemModulesEnum.ADDINS
  )?.moduleId;
  const permissions = PermissionService(moduleId);

  // PERMISSION FIX: If permissions array is empty but localStorage has permissions, manually set them
  let effectivePermissions = permissions;
  if (permissions.length === 0) {
    const storedPerms = JSON.parse(localStorage.getItem('modulePermissions') || '[]').find(m => m.moduleId === 67);
    if (storedPerms?.features) {
      effectivePermissions = storedPerms.features.map(f => f.featureName);
      // Using localStorage permissions as effective permissions
    }
  }
  const applyFilterHandler = (Filter) => {
    ClearSelectionData();
    setQuery((prevState) => {
      return {
        ...prevState,
        PageNumber: 1,
        Filter: {
          Status: selectedStatus,
          vendorIds: selectedVendors,
          addInType: selectedAddInTypes,
          applicableTo: selectedApplicableTo,
          addInServiceCost: selectedCostTypes,
          publishStatus: selectedPublishStatus,
        },
      };
    });
  };

  const clearFilterHandler = () => {
    setSelectedStatus([]);
    setSelectedVendors([]);
    setSelectedAddInTypes([]);
    setSelectedCostTypes([]);
    setSelectedApplicableTo([]);
    setSelectedPublishStatus([]);
  };

  const onSearchHandler = (event) => {
    ClearSelectionData();
    setTimeout(() => {
      setQuery((prevState) => {
        return {
          ...prevState,
          PageNumber: 1,
          searchText: event.target.value,
        };
      });
    }, 1000);
  };

  const sortHandler = (sortOrder, sortBy) => {
    setQuery((prevState) => {
      if (prevState.SortColumn === sortBy) {
        return {
          ...prevState,
          SortType: sortOrder === "asc" ? "desc" : "asc",
        };
      } else {
        return {
          ...prevState,
          SortColumn: sortBy,
          SortType: "asc",
        };
      }
    });
  };

  const handleChangePageNumber = (event, newPage) => {
    setQuery((prevState) => {
      return { ...prevState, PageNumber: newPage };
    });
  };
  /*istanbul ignore next */
  const pageSizeChangeHandler = (PageSize) => {
    setQuery((prevState) => {
      return { ...prevState, PageSize: PageSize, PageNumber: 1 };
    });
  };

  const onCheckboxChangeHandler = (e, value) => {
    const { checked } = e.target;
    if (value === "all") {
      setVendorTableData((items) => {
        SelectionFilter(items, "multiple", checked, "addInId");
        return items.map((data) => {
          return {
            ...data,
            isChecked: checked,
          };
        });
      });
    } else {
      setVendorTableData((items) => {
        return items.map((user) => {
          let userRecord = { ...user };
          if (user.addInId === value) {
            SelectionFilter(user, "single", checked, "addInId");
            userRecord.isChecked = checked;
          }
          return userRecord;
        });
      });
    }
  };

  const onEdit = (vendor) => {
    // Disable edit if published status is modified
    if (vendor.publishStatus === ContentPublishStatus.MODIFIED) {
      vendor.editable = false;
      addInsContext.setEditMode(false);
      return;
    }

    vendor.editable = true;
    addInsContext.setEditMode(true);
    history.push(`/AddIns-Services/${vendor.addInId}`);
  };
  const onView = (vendor) => {
    vendor.editable = false;
    addInsContext.setEditMode(false);
    history.push(`/AddIns-Services/${vendor.addInId}`);
  };

  const onCancelTableColumnSelection = () => {
    setSelectionColumns();
    setTableColumnModalVisibility(false);
  };

  const onSaveTableColumnSelection = (componentName, columns) => {
    let oldData = localStorage.getItem("selectedColumns")
      ? JSON.parse(localStorage.getItem("selectedColumns"))
      : null;
    if (oldData) {
      let data = { ...oldData, listOfAddInsServiceDataColumns: columns };
      localStorage.setItem("selectedColumns", JSON.stringify(data));
    }
    setSelectionColumns();
    setTableColumnModalVisibility(false);
  };

  const setSelectionColumns = () => {
    let selectedCols = localStorage.getItem("selectedColumns")
      ? JSON.parse(localStorage.getItem("selectedColumns"))
      : null;
    let adminCols = selectedCols?.listOfAddInsServiceDataColumns
      ? selectedCols?.listOfAddInsServiceDataColumns
      : null;
    if (adminCols) {
      const selectedByLabel = new Map(
        adminCols.map((column) => [column.label, column])
      );
      const normalizedColumns = listofAddInsServicesDataColumns.map((column) => {
        const storedColumn = selectedByLabel.get(column.label);
        return storedColumn
          ? { ...column, isSelected: storedColumn.isSelected }
          : { ...column };
      });
      setSelectedColumns(normalizedColumns);
    } else {
      setSelectedColumns(listofAddInsServicesDataColumns.map((column) => ({
        ...column,
      })));
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const loadFilterOptions = async () => {
    try {
      const [vendorResponse, masterDataResponse] = await Promise.all([
        ApiServices.httpGet(VENDOR_DROPDOWN),
        ApiServices.httpGet(`${MASTER_DATA}?include=enumMasterData`),
      ]);

      if (vendorResponse?.responseStatus?.isSuccess) {
        let vendors = [];
        if (Array.isArray(vendorResponse?.result)) {
          vendors = vendorResponse.result;
        } else if (Array.isArray(vendorResponse?.result?.records)) {
          vendors = vendorResponse.result.records;
        }
        setVendorOptions(
          vendors
            .map((vendor) => ({
              value: vendor?.vendorId ?? vendor?.id ?? vendor?.value,
              label: vendor?.name ?? vendor?.label ?? vendor?.displayName,
            }))
            .filter((vendor) => vendor.value !== undefined && vendor.label)
        );
      }

      const enumMasterData = masterDataResponse?.result?.enumMasterData || {};
      // Debug log to check the structure of enumMasterData
      const addInTypes = enumMasterData.addInType || [];
      const options = addInTypes.map((item) => ({
        label: item.value,
        value: Number(item.key),
      }));
      setAddInTypeOptions(options);

      const addInServiceCost = enumMasterData.addInServiceCost || [];
      const costOptions = addInServiceCost.map((item) => ({
        label: item.value,
        value: Number(item.key),
      }));
      setCostTypeOptions(costOptions);

      const addInApplicableTo = enumMasterData.addInApplicableTo || [];
      const applicableTo = addInApplicableTo.map((item) => ({
        label: item.value,
        value: Number(item.key),
      }));
      setApplicableToOptions(applicableTo);
    } catch (error) {
      console.error("Failed to load filter options", error);
    }
  };


  const onToggleHandler = async (
    column,
    userId,
    contentSubscriberStatus,
    e,
    selectedVendor
  ) => {
    // Status toggle clicked with permission check

    // Check if user has Update permission
    if (!effectivePermissions.includes('Update')) {
      // No Update permission - status toggle blocked
      toast.error("You don't have permission to update status");
      return;
    }

    setSelectedVendor(selectedVendor);
    if (selectedVendor.status === 1) {
      // Showing inactivate confirmation dialog
      handleConfirmationOpen(
        "Inactivate",
        "Are you sure you want to mark the Add-in as Inactive?"
      );
    } else {
      // Directly activating AddIn
      changeContentStatus(selectedVendor, "", STATUS_ENUM.ACTIVE);
    }
  };
  const changeContentStatus = async (vendorObj, reason, status) => {
    try {
      // Changing status

      const response = await ApiServices.httpPut(ADDIN_STATUS, {
        userId: vendorObj?.userId ?? 0,
        addInId: vendorObj?.addInId ?? vendorObj?.vendorId ?? 0,
        reason: reason,
        status: status,
      });

      if (response.responseStatus.isSuccess) {
        toast.success(response.responseStatus.description);
        handleConfirmationClose();

        // Add delay to ensure database commit before refresh
        // Status change successful, refreshing data after delay
        setTimeout(() => {
          vendorDetails();
        }, 1000); // 1 second delay for better reliability
      } else {
        console.error("❌ API Error:", response.responseStatus.error);
        toast.error(response.responseStatus.error);
      }
    } catch (event) {
      console.error("❌ Network/Server Error:", event);
      toast.error("Internal server error");
    }
  };

  const deleteAddIn = async (addIn) => {
    try {
      showLoader(true);
      const response = await ApiServices.httpDelete(ADDIN, {
        addInId: addIn?.addInId ?? 0,
        status: 0,
        userId: 0,
      });
      showLoader(false);

      if (response.responseStatus?.isSuccess) {
        toast.success(response.responseStatus.description);
        handleConfirmationClose();
        vendorDetails();
      } else {
        toast.error(response.responseStatus?.error);
      }
    } catch (event) {
      showLoader(false);
      toast.error("Internal server error");
    }
  };

  const onActionHandler = (actionName, addIn) => {
    setSelectedVendor(addIn);
    if (actionName === "Delete") {
      if (addIn.publishStatus === ContentPublishStatus.PUBLISHED && addIn.status === 1) {
        return;
      }
      handleConfirmationOpen(
        "Delete",
        "Are you sure you want to delete this Add-in?"
      );
    }

    if (actionName === "Copy") {
      addInsContext.setEditMode(true);
      history.push(`/AddIns-Services/${addIn.addInId}?mode=copy`);
    }
  };

  const vendorDetails = async () => {
    try {
      showLoader(true);
      const vendorData = await ApiServices.httpPost(
        ADDIN_LIST,
        buildAddInsListPayload()
      );
      showLoader(false);
      if (vendorData.responseStatus.isSuccess) {
        // Refreshed AddIns data
        const records = vendorData?.result?.records || [];

        // Get currently selected IDs from localStorage
        const currentlySelected = GetAllSelectedIds("addInId");

        // Set isChecked based on current selection
        const recordsWithSelection = records.map(record => ({
          ...record,
          isChecked: currentlySelected.includes(record.addInId),
          disableToggleButton:
            record.publishStatus === ContentPublishStatus.DRAFT ||
            record.disableToggleButton,
        }));

        // Debug: Log status values for all items to see what's being displayed
        console.table(records.map((item, index) => ({
          Index: index + 1,
          Name: item.name,
          Status: item.status,
          StatusText: item.status === 1 ? 'ACTIVE' : 'INACTIVE',
          AddInId: item.addInId,
          IsChecked: currentlySelected.includes(item.addInId)
        })));

        setVendorTableData(recordsWithSelection);
        setTotalPages(vendorData?.result?.totalPages);
        setPageSize(vendorData?.result?.pageSize);
      } else {
        toast.error(vendorData.responseStatus.error);
      }
    } catch (e) {
      showLoader(false);
      toast.error();
    }
  };

  const handleExport = async () => {
    try {
      // Get selected add-in IDs
      const selectedAddInIds = GetAllSelectedIds("addInId");

      // Debug: Check what's in localStorage
      console.log("Raw selection data from localStorage:", localStorage.getItem("selectionFilter"));
      console.log("Parsed selected IDs:", selectedAddInIds);

      // Show appropriate message based on selection
      if (selectedAddInIds && selectedAddInIds.length > 0) {
        console.log(`Exporting ${selectedAddInIds.length} selected add-ins:`, selectedAddInIds);
      } else {
        console.log("Exporting all add-ins based on current filters");
      }

      const exportPayload = {
        searchText: query.searchText || "",
        sortColumn: query.SortColumn,
        sortType: query.SortType || "",
        filter: {
          vendorIds: selectedVendors,
          addInType: selectedAddInTypes,
          applicableTo: selectedApplicableTo,
          status: selectedStatus,
          publishStatus: selectedPublishStatus,
          addInServiceCost: selectedCostTypes,
          selectedColumns: [
            "Add-ins Name",
            "Vendor",
            "Add-ins Type",
            "Cost Type",
            "Published",
            "Status",
          ],
        },
        // Add SelectedIds at top level if any items are selected
        ...(selectedAddInIds && selectedAddInIds.length > 0 && {
          SelectedIds: selectedAddInIds
        })
      };
      showLoader(true);
      const exportedContent = await ApiServices.httpPost(
        ADDIN_EXPORT,
        exportPayload
      );
      if (exportedContent?.result?.file) {
        ExportToExcelHandler(
          exportedContent.result.file.fileContents,
          exportedContent.result.file.fileDownloadName
        );
      } else {
        toast.error(exportedContent?.responseStatus?.error);
      }
      showLoader(false);
    } catch (e) {
      showLoader(false);
      toast.error("Internal server error");
    }
  };
  return (
    <Grid spacing={2} container className="reports-container">
      <Grid container item xs={12}>
        <Grid item xs={10}>
          <Box pt={2} pr={4} pl={4} pb={0}>
            <h5>Add-Ins/Services</h5>
          </Box>
        </Grid>
      </Grid>

      <Grid item xs={12} justifyContent={"flex-end"} display={"flex"} mr={5}>
        <div className="add-welcome-widgets">
          <div>
            <Popover
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              id={"simple-popover"}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
            >
              <div className="expanded-filter">
                <div className="filter-options">
                  <List
                    sx={{
                      width: "100%",
                      maxWidth: 360,
                      bgcolor: "background.paper",
                    }}
                    component="nav"
                    aria-labelledby="nested-list-subheader"
                    subheader={
                      <ListSubheader component="div" id="nested-list-subheader">
                        Filters will be applied to your grid
                      </ListSubheader>
                    }
                  >
                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2bh-content"
                        id="panel2bh-header"
                      >
                        <Typography sx={{ width: "33%", flexShrink: 0 }}>
                          Vendor
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <CheckboxList
                          id="vendor"
                          options={vendorOptions}
                          onChange={onFilterVendorChangeHandler}
                          selectedValues={selectedVendors}
                        />
                      </AccordionDetails>
                    </Accordion>
                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel3bh-content"
                        id="panel3bh-header"
                      >
                        <Typography sx={{ width: "33%", flexShrink: 0 }}>
                          Add-ins Type
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <CheckboxList
                          id="add-ins-type"
                          options={addInTypeOptions}
                          onChange={onFilterAddInTypeChangeHandler}
                          selectedValues={selectedAddInTypes}
                        />
                      </AccordionDetails>
                    </Accordion>
                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel4bh-content"
                        id="panel4bh-header"
                      >
                        <Typography sx={{ width: "33%", flexShrink: 0 }}>
                          Cost Type
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <CheckboxList
                          id="cost-type"
                          options={costTypeOptions}
                          onChange={onFilterCostTypeChangeHandler}
                          selectedValues={selectedCostTypes}
                        />
                      </AccordionDetails>
                    </Accordion>
                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel5bh-content"
                        id="panel5bh-header"
                      >
                        <Typography sx={{ width: "33%", flexShrink: 0 }}>
                          Applicable To
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <CheckboxList
                          id="applicable-to"
                          options={applicableToOptions}
                          onChange={onFilterApplicableToChangeHandler}
                          selectedValues={selectedApplicableTo}
                        />
                      </AccordionDetails>
                    </Accordion>
                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                      >
                        <Typography sx={{ width: "33%", flexShrink: 0 }}>
                          Status
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <CheckboxList
                          id="status"
                          options={[
                            { value: 1, label: "Active" },
                            { value: 0, label: "Inactive" },
                          ]}
                          onChange={onFilterStatusChangeHandler}
                          selectedValues={selectedStatus}
                        />
                      </AccordionDetails>
                    </Accordion>
                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel6bh-content"
                        id="panel6bh-header"
                      >
                        <Typography sx={{ width: "33%", flexShrink: 0 }}>
                          Published
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <CheckboxList
                          id="publish-status"
                          options={[
                            {
                              value: ContentPublishStatus.DRAFT,
                              label: "Draft",
                            },
                            {
                              value: ContentPublishStatus.PUBLISHED,
                              label: "Published",
                            },
                            {
                              value: ContentPublishStatus.MODIFIED,
                              label: "Modified",
                            },
                          ]}
                          onChange={onFilterPublishStatusChangeHandler}
                          selectedValues={selectedPublishStatus}
                        />
                      </AccordionDetails>
                    </Accordion>
                  </List>
                </div>
                <div className="modal-footer">
                  <Button
                    variant="outlined"
                    className="action-button mr-4"
                    onClick={clearFilterHandler}
                  >
                    Clear
                  </Button>
                  <Button
                    variant="contained"
                    className="action-button"
                    onClick={() => {
                      applyFilterHandler();
                      handleClose();
                    }}
                  >
                    Apply
                  </Button>
                </div>
              </div>
            </Popover>
          </div>

          {permissions?.includes(PermissionEnum.CREATE) && (
            <Tooltip placement="bottom" title="Add New ADD-Ins/Service">
              <AddOutlinedIcon
                name="add-icon"
                onClick={() => {
                  addInsContext.setEditMode(true);
                  history.push(`/AddIns-Services`);
                }}
              />
            </Tooltip>
          )}

          {
            <Tooltip placement="bottom" title="Filter">
              <FilterAltOutlinedIcon
                onClick={handleClick}
                title="filter-icon"
              />
            </Tooltip>
          }
          {
            <Tooltip placement="bottom" title="Change View">
              <BorderColorIcon
                data-testid="TableColumnSelectionIcon"
                onClick={() => {
                  setTableColumnModalVisibility(true);
                }}
              />
            </Tooltip>
          }
          {
            <Tooltip placement="bottom" title="Export to Excel">
              <IosShareRoundedIcon
                data-testid="IosShareRoundedIcon"
                onClick={handleExport}
              />
            </Tooltip>
          }
        </div>
      </Grid>

      <Grid item xs={12}>
        <Box pr={4} pl={4} pb={0}>
          {/* Passing permissions to DataTable */}

          <DataTable
            uniqueKey="addInId"
            query={query}
            columns={selectedColumns}
            onEdit={(data) => onEdit(data)}
            onView={(data) => onView(data)}
            adminTable={vendorTable}
            onSearch={onSearchHandler}
            onSort={sortHandler}
            onPageSizeChange={pageSizeChangeHandler}
            handleChangePage={handleChangePageNumber}
            totalPages={totalPages}
            pageSize={pageSize}
            onCheckboxChange={onCheckboxChangeHandler}
            checkboxesNotRequired={true}
            permissions={effectivePermissions}
            actionHandler={onActionHandler}
            onToggle={onToggleHandler}
            showToggle={true}
            showEdit={true}
            showView={true}
            showMenu={true}
          />

          {tableColumnModalVisibility && (
            <TableColumnModal
              isOpen={tableColumnModalVisibility}
              onCancelTableColumnSelection={onCancelTableColumnSelection}
              onSaveTableColumnSelection={onSaveTableColumnSelection}
              selection={selectedColumns}
            />
          )}
          <Confirmation
            open={confirmation}
            handleClose={handleConfirmationClose}
            title={confirmationMessage}
            cancelButtonLabel="No"
            confirmButtonLabel="Yes"
            showReason={confirmationAction === "Inactivate" && selectedVendor?.publishStatus === ContentPublishStatus.PUBLISHED}
            onCancel={() => {
              handleConfirmationClose();
            }}
            onConfirm={(e, reason) => {
              if (confirmationAction === "Delete") {
                deleteAddIn(selectedVendor);
              }
              else if (confirmationAction === "Inactivate") {
                changeContentStatus(selectedVendor, reason, STATUS_ENUM.INACTIVE);
              } else {
                changeContentStatus(selectedVendor, "", STATUS_ENUM.INACTIVE);
              }
            }}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default AddInsList;
